import Home from '@/components/Home.vue'
import About from '@/components/About.vue'
import Experience from '@/components/Experience.vue'
import ExperienceItem from '@/components/ExperienceItem.vue'
import Education from '@/components/Education.vue'
import Portfolio from '@/components/Portfolio.vue'
import PortfolioItem from '@/components/PortfolioItem.vue'
import Contact from '@/components/Contact.vue'
import PageNotFound from '@/components/PageNotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      routeNum: '00',
      showInNavigation: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      routeNum: '01',
      showInNavigation: true
    }
  },
  {
    path: '/experiences',
    name: 'Experiences',
    component: Experience,
    meta: {
      routeNum: '02',
      showInNavigation: true
    }
  },
  {
    path: '/experiences/:id',
    name: 'Experience',
    component: ExperienceItem,
    props: true,
    meta: {
      showInNavigation: false
    }
  },
  {
    path: '/education',
    name: 'Education',
    component: Education,
    meta: {
      routeNum: '03',
      showInNavigation: true
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Portfolio,
    meta: {
      routeNum: '04',
      showInNavigation: true
    }
  },
  {
    path: '/projects/:id',
    name: 'Project',
    component: PortfolioItem,
    props: true,
    meta: {
      showInNavigation: false
    }
  },
  {
    path: '/lets-connect',
    name: 'Connect',
    component: Contact,
    meta: {
      routeNum: '05',
      showInNavigation: true
    }
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      showInNavigation: false,
    }
  },
]

export default routes;